import { translate, translateFormatter, type RichTextFormatter } from '@/core/localization/translate';
export const {
  advantageAppDescription,
  saveMoneyDescription,
  saveMoneyDescriptionV2,
  disponibilityV2Description,
  paymentDescription,
  saveMoneyDescriptionB2c,
  trustedPartnerDescriptionB2c,
  paymentDescriptionB2c,
  deferredPayment
} = translate({
  "advantageAppDescription": "Easy invoice management and dedicated app",
  "saveMoneyDescription": "+ 400,000 Pro references at negotiated prices",
  "saveMoneyDescriptionV2": "Big brands at negotiated prices.",
  "saveMoneyDescriptionB2c": "The DIY, home and garden specialist",
  "disponibilityV2Description": "by email, chat or phone at 01.75.85.01.70",
  "trustedPartnerDescription": "1 in 2 French craftsmen is on ManoManoPro",
  "trustedPartnerDescriptionB2c": "More than 7 million individual and professional customers",
  "paymentDescription": "Purchase on account: Pay within 30 days",
  "paymentDescriptionB2c": "Payment in 3x or up to 30 days free of charge",
  "deferredPayment": "Deferred payment up to 30 days"
});
export const deliveryV2Description = translateFormatter<{
  link: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Reliable delivery for pros. "
}, {
  "type": 8,
  "value": "link",
  "children": [{
    "type": 0,
    "value": "See more"
  }]
}], undefined, undefined, "en");
export const deliveryDescription = translateFormatter<{
  link: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Reliable delivery"
}], undefined, undefined, "en");
export const disponibilityV2DescriptionV2 = translateFormatter<{
  phoneNumber: string;
}>([{
  "type": 0,
  "value": "Pro advisors available Mon-Fri: "
}, {
  "type": 1,
  "value": "phoneNumber"
}], undefined, undefined, "en");